import React, { useState } from 'react'
import { SelectWrapper, Label } from '../Input/Input.styled'
import { HonestSelect } from './HonestSelect'
import { IHonestSelectInput } from 'types/select.interface'
import { Flex, InvalidText } from 'styling/GlobalStyles'

export const HonestSelectInput = (props: IHonestSelectInput) => {
  const [openOptions, setOpenOptions] = useState(false)
  const [blured, setBlured] = useState(false)

  return (
    <SelectWrapper view={props.view} width={props.width} invalid={props.invalid ? 'true' : ''} nomarg={props.nomarg}>
      <Label labelText={props.labelText}>
        {props.labelText}
      </Label>
      {props.required && <span style={{ color: 'red' }} >*</span>}
      <HonestSelect
        onBlur={() => {
          setBlured(true)
          setTimeout(() => {
            setOpenOptions(false)
          }, 150)
        }}
        errorWhenEmpty={props.errorWhenEmpty}
        menuTop={props.menuTop}
        noX={props.noX}
        invalid={props.invalid}
        isNone={props.isNone}
        openOptions={openOptions}
        setOpenOptions={setOpenOptions}
        {...props} />
      <article>{props.invalid && blured && <Flex width='100%' justend  > <InvalidText>This field is required</InvalidText>  </Flex>}</article>

    </SelectWrapper>
  )
}
